import { z } from "zod";

export const getUserConsentResponseSchema = z.object({
    userId: z.string(),
    lastAcceptedAt: z.string().nullable(),
});

export const createUserConsentRequestSchema = z.object({
    acceptedAt: z.string().nullable(),
});

export type GetUserConsentResponseDto = z.infer<typeof getUserConsentResponseSchema>;
export type CreateUserConsentRequestDto = z.infer<typeof createUserConsentRequestSchema>;
